import { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem('theme');
    if (saved) return saved;
    return 'auto';
  });

  const [resolvedTheme, setResolvedTheme] = useState('light');

  useEffect(() => {
    const getAutoTheme = () => {
      const hour = new Date().getHours();
      // Dark from 6 PM (18) to 6 AM (6)
      return (hour >= 18 || hour < 6) ? 'dark' : 'light';
    };

    const updateTheme = () => {
      let newResolvedTheme;
      if (theme === 'auto') {
        newResolvedTheme = getAutoTheme();
      } else {
        newResolvedTheme = theme;
      }
      setResolvedTheme(newResolvedTheme);
      
      // Update document class
      const root = window.document.documentElement;
      root.classList.remove('light', 'dark');
      root.classList.add(newResolvedTheme);
    };

    updateTheme();
    localStorage.setItem('theme', theme);

    // Check every minute for auto theme changes
    const interval = setInterval(updateTheme, 60000);
    return () => clearInterval(interval);
  }, [theme]);

  const value = {
    theme,
    setTheme,
    resolvedTheme,
    isDark: resolvedTheme === 'dark'
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
